import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import JasperNoBooks from '../../pages/errorPages/JasperNoBooks';
import JasperCard from '../../pages/JasperCard';
import { ClassSubject } from '../../features/classSubjects/classSubjectsSlice';

interface JasperBookListProps {
    classSubjects: any; 
}
  
const JasperBookListComponent: React.FC<JasperBookListProps> = ({ classSubjects }) => {

    const searchString = useSelector(
        (state: RootState) => state.JasperHeaderSearch.searchString
    );

    const jasperBooks = useSelector(
        (state: RootState) => state.JasperBooks.data
    );
    const isJasperLoading = useSelector(
        (state: RootState) => state.jasper.isJasperLoading
    );
    const filteredBooks = jasperBooks.filter(
        (book: {
        classid: string;
        classname: string;
        subjectid: any;
        bookdetails: { id: number; jasperenabled: boolean; name: string };
    }) => {
        // Check Jasper enabled
        if (!book?.bookdetails?.jasperenabled) return false;

        // Find matching class and subject
        const classMatch = classSubjects?.find(
            (cs: ClassSubject) => +cs.classId === +book.classid
        );
        
        const subjectMatch = classMatch?.subjects?.find(
            (subject: any) => +subject.subjectId === +book.subjectid
        );

        if (!classMatch || !subjectMatch) return false;

        // Check teaching platform
        if (subjectMatch.teaching_platform === 'Active Teach') return false;

        // Check search match
        const lowerSearch = searchString?.toLowerCase() || '';
        const bookName = book?.bookdetails?.name?.toLowerCase() || '';
        const className = book?.classname?.toLowerCase() || '';
        
        return bookName.includes(lowerSearch) || className.includes(lowerSearch);
    });

    const sortedBooks = useMemo(() => {
        return [...filteredBooks].sort((a: any, b: any) => {
            const classNameComparison = (a?.classname || '').localeCompare(
                b?.classname || ''
            );
            if (classNameComparison !== 0) return classNameComparison;
            return (a?.bookdetails?.subject_name || '').localeCompare(
                b?.bookdetails?.subject_name || ''
            );
        });
    }, [filteredBooks, searchString]);

    if (filteredBooks.length === 0 && !isJasperLoading)
        return <JasperNoBooks />;

    return (
        <div className="grid gap-4 ml-4 pb-32 pl-8 pr-28 grid-cols-3 ">
            {sortedBooks.map((book: any) => (
                <JasperCard
                    key={book.uid}
                    title={book.bookdetails?.name}
                    isLocked={false}
                    className={book?.classname}
                    series={book.bookdetails?.series}
                    cover={book.bookdetails?.thumbnail_url}
                    book_url={book.bookdetails?.url}
                    book_id={book.bookdetails?.id}
                    onClick={() => {}}
                />
            ))}
        </div>
    );
};

export default React.memo(JasperBookListComponent);